import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { noopCallback, useGetData } from '../../../api/common/hooks';
import { fetchAllImpactLabels } from '../../../api/model/input/impacts';
import { useIsTeam } from '../../../common/generic/hooks';
import { storeImpactLabels } from '../../../untidy/redux/actions/actions';
import { getVersionAndReleaseIfExists } from '../../../untidy/redux/selectors';

/**
 * Hook that fetches impact labels and stores them to redux state
 * (if team user and not in mapper search)
 */
export function useLoadAllImpactLabels() {
  const { version } = useSelector(getVersionAndReleaseIfExists);
  const isTeam = useIsTeam();
  const shouldFetch = isTeam && version;

  const { data } = useGetData(shouldFetch ? async () => await fetchAllImpactLabels(version) : noopCallback, [
    shouldFetch,
    isTeam,
    version,
  ]);
  const dispatch = useDispatch();
  useEffect(() => {
    if (data) {
      dispatch(storeImpactLabels(data));
    }
  }, [data]);
  return data;
}
